module.exports = __webpack_public_path__ + "img/7.265103b5.png";